(() => {
  const body = document.body;
  if (!body || !body.classList.contains('hiq-shell') || body.classList.contains('hiq-template-index')) return;

  const installOfficialLogo = () => {
    const source = body.dataset.hiqOfficialLogo;
    if (!source) return;
    document.querySelectorAll('.header-logo__image-container').forEach((container) => {
      const image = container.querySelector('.header-logo__image');
      if (!image) return;

      container.classList.add('hiq-official-logo-crop');
      image.classList.add('hiq-official-logo-source');

      if (image.dataset.hiqOfficialLogo === 'true') return;
      image.dataset.hiqOfficialLogo = 'true';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.removeAttribute('style');
      image.src = source;
      image.width = 1024;
      image.height = 1024;
    });
  };

  installOfficialLogo();

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setScrolledState = () => {
    body.classList.toggle('hiq-scrolled', window.scrollY > 18);
  };

  setScrolledState();
  window.addEventListener('scroll', setScrolledState, { passive: true });

  const revealTargets = [
    ...document.querySelectorAll('#MainContent > .shopify-section'),
    ...document.querySelectorAll('product-card.product-card'),
    ...document.querySelectorAll('.product-details, .media-gallery, .cart-page__items, .cart-page__summary, .shopify-policy__container')
  ];

  const uniqueTargets = [...new Set(revealTargets)];

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    uniqueTargets.forEach((element) => element.classList.add('hiq-in'));
  } else {
    uniqueTargets.forEach((element) => element.classList.add('hiq-reveal'));

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hiq-in');
        currentObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -3% 0px', threshold: 0.01 });

    uniqueTargets.forEach((element) => observer.observe(element));
  }

  const productGallery = document.querySelector('.media-gallery');
  const canTilt = productGallery && !prefersReducedMotion && window.matchMedia('(pointer: fine)').matches;

  if (canTilt) {
    productGallery.addEventListener('pointermove', (event) => {
      const bounds = productGallery.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      productGallery.style.setProperty('--hiq-tilt-x', `${(x * 2.2).toFixed(2)}deg`);
      productGallery.style.setProperty('--hiq-tilt-y', `${(-y * 1.8).toFixed(2)}deg`);
    });

    productGallery.addEventListener('pointerleave', () => {
      productGallery.style.setProperty('--hiq-tilt-x', '0deg');
      productGallery.style.setProperty('--hiq-tilt-y', '0deg');
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('product-card.product-card').forEach((card) => {
      card.classList.add('hiq-in');
    });
  });
})();

(() => {
  const body = document.body;
  if (!body || !body.classList.contains('hiq-shell') || body.classList.contains('hiq-template-index')) return;

  const createPurchaseNotes = () => {
    if (!body.classList.contains('hiq-template-product')) return;
    const productForm = document.querySelector('.product-details form[action*="/cart/add"]');
    if (!productForm || document.querySelector('.hiq-product-purchase-notes')) return;

    const notes = document.createElement('ul');
    notes.className = 'hiq-product-purchase-notes';
    notes.setAttribute('aria-label', 'Purchase information');
    notes.innerHTML = `
      <li><span aria-hidden="true">✓</span><strong>Secure checkout</strong></li>
      <li><span aria-hidden="true">↗</span><strong>Shipping calculated at checkout</strong></li>
      <li><span aria-hidden="true">i</span><strong>Product information below</strong></li>
    `;
    productForm.insertAdjacentElement('afterend', notes);
  };

  const organizeProductDetails = () => {
    if (!body.classList.contains('hiq-template-product')) return;
    const candidates = [...document.querySelectorAll('.product-details rte-formatter.rte, .product-details .text-block.rte')]
      .filter((element) => !element.dataset.hiqAccordion && element.textContent.trim().length > 140)
      .sort((a, b) => b.textContent.trim().length - a.textContent.trim().length);
    const source = candidates[0];
    if (!source) return;

    source.dataset.hiqAccordion = 'true';
    const textWalker = document.createTreeWalker(source, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = textWalker.nextNode())) {
      textNode.textContent = textNode.textContent
        .replace(/of the highest quality and efficacy to keep you performing at your best,?/gi, 'made for straightforward daily use,')
        .replace(/highest quality and efficacy/gi, 'straightforward daily support');
    }
    const panel = document.createElement('details');
    panel.className = 'hiq-product-copy';
    const summary = document.createElement('summary');
    summary.innerHTML = '<span>Product details</span><small>Ingredients, use + cautions</small>';
    const content = document.createElement('div');
    content.className = 'hiq-product-copy__content';

    while (source.firstChild) content.appendChild(source.firstChild);
    panel.append(summary, content);
    source.appendChild(panel);
  };

  const enhanceCollectionHeading = () => {
    if (!body.classList.contains('hiq-template-collection')) return;
    const hero = document.querySelector('#MainContent > .shopify-section:first-child');
    if (!hero || hero.dataset.hiqCollectionEnhanced) return;
    hero.dataset.hiqCollectionEnhanced = 'true';

    let heading = hero.querySelector('h1');
    if (!heading) {
      const titleText = hero.querySelector('.text-block.h2 p, .text-block p');
      if (titleText) {
        heading = document.createElement('h1');
        heading.className = titleText.className;
        heading.innerHTML = titleText.innerHTML;
        titleText.replaceWith(heading);
      }
    }

    const descriptionText = [...hero.querySelectorAll('p')]
      .map((element) => element.textContent.trim())
      .filter(Boolean)
      .join(' ');
    if (descriptionText || !heading) return;

    const intro = document.createElement('p');
    intro.className = 'hiq-collection-intro';
    if (location.pathname.includes('performance-nutrition')) {
      intro.textContent = 'Focused nutrition for training, movement, and recovery—organized for a faster, clearer shop.';
    } else if (location.pathname.includes('longevity-essentials')) {
      intro.textContent = 'Daily supplements selected for simple, consistent wellness routines and easier product comparison.';
    } else {
      intro.textContent = `Explore ${heading.textContent.trim()} with clear product details and simple navigation.`;
    }
    heading.insertAdjacentElement('afterend', intro);
  };

  const addCartNotes = () => {
    if (!body.classList.contains('hiq-template-cart')) return;
    const checkout = document.querySelector('button[name="checkout"], .cart__checkout-button');
    const summary = checkout?.closest('.cart-page__summary, .cart__summary, .cart-summary');
    if (!checkout || !summary || summary.querySelector('.hiq-cart-checkout-notes')) return;

    const notes = document.createElement('div');
    notes.className = 'hiq-cart-checkout-notes';
    notes.innerHTML = `
      <span><b aria-hidden="true">✓</b> Secure checkout</span>
      <span><b aria-hidden="true">i</b> Shipping and taxes calculated at checkout</span>
      <a href="/pages/contact">Need help before ordering?</a>
    `;
    checkout.insertAdjacentElement('afterend', notes);
  };

  const positionSupportPanels = () => {
    const firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
    if (!firstSection) return;
    const productSupport = document.querySelector('#MainContent > .hiq-support-band');
    const cartSupport = document.querySelector('#MainContent > .hiq-cart-reassurance');
    if (productSupport) firstSection.insertAdjacentElement('afterend', productSupport);
    if (cartSupport) firstSection.insertAdjacentElement('afterend', cartSupport);
  };

  const enhancePage = () => {
    createPurchaseNotes();
    organizeProductDetails();
    enhanceCollectionHeading();
    addCartNotes();
    positionSupportPanels();
  };

  enhancePage();
  document.addEventListener('shopify:section:load', enhancePage);
})();

(() => {
  const body = document.body;
  const header = document.querySelector('[data-hiq-shared-header]');
  if (!body || !header || body.classList.contains('hiq-template-index')) return;

  const menu = document.querySelector('[data-hiq-shared-menu]');
  const backdrop = document.querySelector('[data-hiq-shared-menu-backdrop]');
  const openButton = header.querySelector('[data-hiq-shared-menu-open]');
  const closeButton = menu?.querySelector('[data-hiq-shared-menu-close]');

  const openMenu = () => {
    menu?.classList.add('is-open');
    backdrop?.classList.add('is-open');
    menu?.setAttribute('aria-hidden', 'false');
    backdrop?.setAttribute('aria-hidden', 'false');
    openButton?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('hiq-lock');
    closeButton?.focus();
  };

  const closeMenu = (restoreFocus = true) => {
    menu?.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    menu?.setAttribute('aria-hidden', 'true');
    backdrop?.setAttribute('aria-hidden', 'true');
    openButton?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('hiq-lock');
    if (restoreFocus) openButton?.focus();
  };

  openButton?.addEventListener('click', openMenu);
  closeButton?.addEventListener('click', () => closeMenu());
  backdrop?.addEventListener('click', () => closeMenu());
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeMenu(false)));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) {
      closeMenu();
      return;
    }

    if (event.key !== 'Tab' || !menu?.classList.contains('is-open')) return;
    const focusable = [...menu.querySelectorAll('a[href], button:not([disabled])')];
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
})();
